if (!customElements.get('dhuni-recently-viewed')) {
  customElements.define('dhuni-recently-viewed', class extends HTMLElement {
    async connectedCallback() {
      const storageKey = 'dhuni-recently-viewed-v1';
      const current = this.dataset.productHandle;
      if (!current) return;
      const controller = new AbortController();
      this.controller?.abort();
      this.controller = controller;
      let history = [];
      try {
        const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
        history = Array.isArray(stored)
          ? [...new Set(stored.filter((handle) => typeof handle === 'string' && handle && handle !== current))].slice(0, 50)
          : [];
      } catch {
        // An old or damaged history must not prevent new visits being recorded.
      }
      try {
        localStorage.setItem(storageKey, JSON.stringify([current, ...history].slice(0, 50)));
      } catch {
        // Browsers that block storage can still display the section's guidance.
      }

      const list = this.querySelector('[data-recent-list]');
      const content = this.querySelector('[data-recent-content]');
      const empty = this.querySelector('[data-recent-empty]');
      list.replaceChildren();
      content.hidden = false;
      list.hidden = true;
      if (empty) {
        empty.hidden = false;
        empty.textContent = history.length
          ? '最近見た石ちゃんを読み込んでいます…'
          : 'ほかの石ちゃんの商品ページを見ると、ここに最近見た石ちゃんが表示されます。';
      }
      const limit = Math.min(Number(this.dataset.limit) || 15, 20);
      const root = this.dataset.rootUrl.replace(/\/?$/, '/');
      const loadCard = async (handle) => {
        try {
          const url = new URL(`${root}products/${encodeURIComponent(handle)}`, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) return null;
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          return document.querySelector('template[data-recent-card]')?.content.querySelector('li') || null;
        } catch {
          return null;
        }
      };

      let count = 0;
      // Small batches preserve recency while skipping unavailable or deleted products.
      for (let index = 0; index < history.length && count < limit; index += 4) {
        const cards = await Promise.all(history.slice(index, index + 4).map(loadCard));
        if (controller.signal.aborted || !this.isConnected) return;
        for (const card of cards) {
          if (!card || count >= limit) continue;
          list.append(document.importNode(card, true));
          count += 1;
        }
        if (count) {
          list.hidden = false;
          if (empty) empty.hidden = true;
        }
      }
      if (!count && history.length && empty) {
        empty.textContent = '表示できる石ちゃんがありません。ほかの商品ページを見てから、もう一度ご覧ください。';
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
